export default __webpack_public_path__ + "static/media/kashier_wallet.666ce6c5.svg";